<app-lms-modal-frame [title]="'Client details mismatch'" [pageHeadWidth]="300">
    <div modal-body class="myh-300 py-3 px-1 text-center">
        <label style="color: red;">
            Warning! <br/>
            There is a difference in the client's information captured
            and the client information returned from the bureau.
        </label>
        <br/><br/>
        <label>
            Client details entered on LMS: Name: <b>{{lmsClientName}}</b>  Surname: <b>{{lmsClientSurname}}</b>
        </label>
        <br/>
        <label>
            Client details from the Bureau: Name: <b>{{bureauClientName}}</b> Surname: <b>{{bureauClientSurname}}</b>
        </label>
        <br/> <br/>
        <label>
           <b> Please Correct the details or Reject the loan.</b>
        </label>
    </div>

    <div modal-actions class="lms-action-bar">
        <button class="btn btn-sm btn-primary m-2" mdbRipple color="primary" (click)="close()"> Continue with loan </button>
        <button class="btn btn-sm btn-primary m-2" mdbRipple color="primary" (click)="reject()"> Reject loan </button>
    </div>
</app-lms-modal-frame>
